<!-- Display a loading spinner while verification is in progress -->
<div *ngIf="isLoading" class="flex justify-content-center"><p-progressSpinner></p-progressSpinner></div>

<!-- Display success message -->
<div *ngIf="!isLoading && isVerified" class="success-message flex flex-column justify-content-center">
  <p-message severity="success" [closable]="false" text="Your account has been successfully activated!"></p-message>
  <button pButton [label]="'AUTH.ACTIVATION.GO_TO_LOGIN' | translate" class="p-button-warning mt-4" [routerLink]="['/' + PUBLICLOGIN]"></button>
</div>

<!-- Display error message -->
<div *ngIf="!isLoading && !isVerified" class="error-message text-center">
  <p-message severity="error">
    <div>
      {{'AUTH.ACTIVATION.VERIFICATION_FAILED' |
      translate}}<br />{{'AUTH.ACTIVATION.PLEASE_TRY_AGAIN_OR_CONTACT_SUPPORT' | translate}}
      <a href="mailto:help@femmepalette.com">help&#64;femmepalette.com</a>.
    </div>
  </p-message>
</div>
